<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                crudName: 'Dimensões',
                newText: 'Cadastrar Dimensão',
                table: 'dimensionsTable',
                columns: ['id', 'name', 'actions'],
                tableData: ['id', 'name'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'name'],
                    filterable: ['id', 'name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': '#',
                        'name' : 'Nome',
                        'actions' : 'Ações'
                    },
                    templates: {},
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'dimensions/',
                dataForm: {
                  title: {
                    add: 'Nova Dimensão',
                    edit: 'Editar Dimensão',
                    view: 'Visualizar Dimensão',
                    icon: 'fa fa-pen'
                  },
                  button: {
                    back: '/dimensions'
                  },
                  url: {
                    model: 'dimensions'
                  },
                  messages: {
                    success: {
                      add: 'Dimensão cadastrada com sucesso!',
                      edit: 'Dimensão alterada com sucesso!'
                    }
                  },
                  fields: [
                    {
                      name: 'name',
                      model: 'name',
                      label: 'Nome',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null
                    },
                  ]
                }
            }
        },
        methods: {
            query: function (query) {
                let columns = {
                    id: 'id',
                    name: 'name',
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
            },
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Dimension/Crud.vue